import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token, css }) => ({
  container: css`
    max-width: 860px;
    margin: 0 auto;
    width: 100%;
  `,

  backLink: css`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: ${token.colorTextSecondary};
    font-size: ${token.fontSizeSM}px;
    margin-bottom: 16px;
    transition: color 0.15s ease;

    &:hover {
      color: ${token.colorText};
    }
  `,

  pageHeader: css`
    margin-bottom: 20px;
  `,

  eyebrow: css`
    display: inline-block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: ${token.colorPrimary};
    margin-bottom: 6px;
  `,

  pageDescription: css`
    color: ${token.colorTextSecondary};
    max-width: 560px;
    margin: 6px 0 0;
  `,

  card: css`
    border-radius: ${token.borderRadiusLG}px;
    background: ${token.colorBgContainer};
    border: 1px solid ${token.colorBorderSecondary};
    overflow: hidden;
  `,

  stepsWrap: css`
    padding: 20px 28px;
    border-bottom: 1px solid ${token.colorBorderSecondary};
    background: ${token.colorFillQuaternary};
  `,

  body: css`
    padding: 28px;
    min-height: 320px;
  `,

  stepContent: css`
    animation: wsStepFadeIn 0.24s ease-out;

    @keyframes wsStepFadeIn {
      from {
        opacity: 0;
        transform: translateY(4px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `,

  sectionHeader: css`
    margin-bottom: 24px;
  `,

  sectionTitle: css`
    margin: 0 0 4px !important;
  `,

  sectionSubtitle: css`
    color: ${token.colorTextSecondary};
    font-size: ${token.fontSizeSM}px;
    margin: 0;
  `,

  fieldGrid: css`
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;

    @media (min-width: 720px) {
      grid-template-columns: 1fr 1fr;
    }
  `,

  fieldRow: css`
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
  `,

  fieldHelper: css`
    display: block;
    color: ${token.colorTextTertiary};
    font-size: ${token.fontSizeSM}px;
    margin-top: 6px;
  `,

  logoBlock: css`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px;
    border: 1px dashed ${token.colorBorder};
    border-radius: ${token.borderRadius}px;
    background: ${token.colorFillQuaternary};
    margin-bottom: 24px;
  `,

  logoHint: css`
    color: ${token.colorTextSecondary};
    font-size: ${token.fontSizeSM}px;
    display: block;
    margin-top: 2px;
  `,

  logoLabel: css`
    font-weight: 500;
    color: ${token.colorText};
    display: block;
  `,

  templateOption: css`
    cursor: pointer;
    border: 1px solid ${token.colorBorderSecondary};
    border-radius: ${token.borderRadius}px;
    padding: 16px 18px;
    transition:
      border-color 0.15s ease,
      box-shadow 0.15s ease,
      background 0.15s ease;
    flex: 1;
    min-width: 220px;
    user-select: none;

    &:hover {
      border-color: ${token.colorPrimaryBorderHover};
      background: ${token.colorBgContainer};
    }
  `,

  templateOptionSelected: css`
    border-color: ${token.colorPrimary} !important;
    background: ${token.controlItemBgActive};
    box-shadow: 0 0 0 1px ${token.colorPrimary}33;
  `,

  presetGrid: css`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 10px;
  `,

  presetCard: css`
    cursor: pointer;
    border: 1px solid ${token.colorBorderSecondary};
    border-radius: ${token.borderRadius}px;
    padding: 12px 14px;
    transition:
      border-color 0.15s ease,
      background 0.15s ease,
      transform 0.15s ease;
    user-select: none;

    &:hover {
      border-color: ${token.colorPrimaryBorderHover};
      background: ${token.colorFillQuaternary};
    }
  `,

  presetCardSelected: css`
    border-color: ${token.colorPrimary} !important;
    background: ${token.controlItemBgActive};
  `,

  authMethodRow: css`
    padding: 10px 12px;
    border-radius: ${token.borderRadius}px;
    transition: background 0.15s ease;
    border-bottom: 1px solid ${token.colorBorderSecondary};

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: ${token.colorFillQuaternary};
    }
  `,

  footer: css`
    padding: 16px 28px;
    border-top: 1px solid ${token.colorBorderSecondary};
    background: ${token.colorBgContainer};
  `,

  stepCounter: css`
    color: ${token.colorTextTertiary};
    font-size: ${token.fontSizeSM}px;
    font-feature-settings: 'tnum';
  `,

  checkBadge: css`
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: var(--brand-fill);
    color: var(--brand-on-fill);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-left: auto;
  `
}))
